// clientjslite: npm `clientjs`(무거운 UA 파서) 경량 대체 shim. vendored EmailContainer 는
// `new ClientJS().getBrowser()` 로 브라우저명을 얻어 `<body data-browser="...">` 에 세팅(브라우저별
// CSS 분기)한다. 그 한 가지 용도만 있으므로 navigator.userAgent 기반 최소 shim 으로 대체(설계 §11.0).
// 외부 npm `clientjs` 와 이름이 겹쳐 혼선을 유발하므로 파일명을 `clientjslite` 로 구분한다.
export class ClientJS {
  private getUserAgent(): string {
    return typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : ''
  }

  // Safari(WebKit 엔진) 계열 판별. @page 인쇄 여백·첨부 미리보기 등 WebKit 고유 처리 분기에 쓴다.
  // 브라우저 이름(userAgent 의 "safari" 문자열)이 아니라 렌더링 엔진(AppleWebKit)으로 판별한다:
  // 데스크탑 WKWebView 의 기본 userAgent 는 실제 Safari 와 달리 "Version/x"·"Safari/x" 토큰이 없어
  // (예: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko)")
  // "safari" 매칭으로는 잡히지 않기 때문이다. AppleWebKit 을 포함하면서 Blink/Gecko 계열
  // (Chrome/Chromium/Edge/Android/Firefox 등 in-app 브라우저 포함)이 아니면 Safari·WKWebView 로 본다.
  isSafari(): boolean {
    const ua = this.getUserAgent()
    return (
      /AppleWebKit/i.test(ua) &&
      !/Chrome|Chromium|Edg|Android|CriOS|FxiOS|OPiOS|SamsungBrowser|mercury/i.test(ua)
    )
  }

  getBrowser(): string {
    const ua = this.getUserAgent()
    if (/edg/i.test(ua)) return 'Edge'
    if (/chrome|crios/i.test(ua)) return 'Chrome'
    if (/firefox|fxios/i.test(ua)) return 'Firefox'
    if (this.isSafari()) return 'Safari'
    return 'Unknown'
  }
}
